webpackJsonp([351],{

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetailRedirect_vue__ = __webpack_require__(2734);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3b0ee9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetailRedirect_vue__ = __webpack_require__(4282);
function injectStyle (ssrContext) {
  __webpack_require__(4280)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3b0ee9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDetailRedirect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3b0ee9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDetailRedirect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(151);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoiceDetailRedirect',
  data: function data() {
    return {
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    user: function user(state) {
      return state.login.user;
    }
  })),
  watch: {
    '$route': {
      handler: function handler() {
        this.checkUserTypeAndRedirect();
      },

      immediate: true
    }
  },
  methods: {
    checkUserTypeAndRedirect: function checkUserTypeAndRedirect() {
      var id = parseInt(this.$route.params.id) || 0;

      if (!id) {
        this.loading = false;
        return;
      }

      try {
        // 根据用户类型判断跳转路径
        if (this.user && this.user.usertype * 1 === 5) {
          // usertype=5 跳转到财务详情页面
          var targetPath = '/invoice-apply/finance/detail/' + id + '?type=detail&from=approve';
          this.$router.replace(targetPath);
        } else {
          // 其他用户类型跳转到普通详情页面
          var _targetPath = '/invoice-apply/detail/' + id + '?type=detail&from=apply';
          this.$router.replace(_targetPath);
        }
      } catch (error) {
        console.error('页面跳转失败：', error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 延迟设置加载状态，确保用户信息已加载
    setTimeout(function () {
      _this.loading = false;
    }, 100);
  }
});

/***/ }),

/***/ 4280:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4281);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3427bb6e", content, true, {});

/***/ }),

/***/ 4281:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".loading-container[data-v-1c3b0ee9]{padding:20px}", "", {"version":3,"sources":["/workspace/src/views/invoice-apply/pages/InvoiceDetailRedirect.vue"],"names":[],"mappings":"AACA,oCAAoC,YAAY,CAC/C","file":"InvoiceDetailRedirect.vue","sourcesContent":["\n.loading-container[data-v-1c3b0ee9]{padding:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-text"},[_vm._v("加载中...")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/invoice-detail-redirect.d07bdf805a2f8c6d4272.js